export const SUCCESS = "success";
export const DANGER = "error";

export const SUBMIT = "Submit";
export const ADD_NEW = "Add New";
export const UPDATE = "Update";
export const DELETE = "Delete";

export const ADD_IMAGE = "Add Image";
